<app-title-section></app-title-section>

<div class="email-application card ng-star-inserted" style="margin-left: 15px; margin-right: 15px; background-color: transparent">
  <div class="content-area-wrapper" style="gap: 16px">
    <!-- Sidebar Left -->
    <core-sidebar
      class="sidebar-left"
      name="email-sidebar"
      overlayClass="body-content-overlay"
      collapsibleSidebar="bs-gt-lg"
    >
      <div class="sidebar">
        <div class="sidebar-content email-app-sidebar">
          <div class="email-app-menu">
            <div class="sidebar-menu-list">
              <div class="list-group list-group-messages">
                <ng-container *ngIf="!showParametreDonneesNav">
                <a
                  routerLink="/main/parametre/entreprise"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('p-e')"
                >

                    <i class="bi bi-buildings  mr-75 size"></i>
                  <span class="align-middle">Profil de l'entreprise</span>
                </a>

                <a
                  routerLink="/main/parametre/document"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('p-d')"
                >
                  <i [size]="18" data-feather="file-text" class="mr-75"></i>
                  <span class="align-middle">Paramètres des documents</span>
                </a>

                <a
                  routerLink="/main/parametre/compte-bancaire"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('c-b')"
                >

                    <i class="bi bi-bank mr-75 size"></i>
                  <span class="align-middle">Compte bancaire</span>
                </a>

                <a
                  routerLink="/main/parametre/taxe-tva"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('t-tva')"
                >

                  <i [size]="18" data-feather="percent" class="mr-75"></i>
                  <span class="align-middle">Taxes et TVA</span>
                </a>

                <a
                  routerLink="/main/parametre/liste-prix"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('l-p')"
                >
                  <i [size]="18" data-feather="file-text" class="mr-75"></i>
                  <span class="align-middle">Liste de prix</span>
                </a>

                <a
                  routerLink="/main/parametre/comptable-parametre"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('c-p')">
                    <i [size]="18" data-feather="briefcase" class="mr-75"></i>
                  <span class="align-middle">Comptable</span>
                </a>

                <a
                  routerLink="/main/parametre/user-and-role"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('u-r')"
                >
                  <i [size]="18" data-feather="users" class="mr-75"></i>
                  <span class="align-middle">Utilisateurs et rôles</span>
                </a>

                <a
                  routerLink="/main/parametre/integration"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('i-p')"
                >
                  <i [size]="18" data-feather="link" class="mr-75"></i>
                  <span class="align-middle">Intégration</span>
                </a>



                <a
                  routerLink="/main/parametre/projets"
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('p-j')"
                >
                  <i [size]="18" data-feather="folder" class="mr-75"></i>
                  <span class="align-middle">Projets</span>
                </a>

                <a
                  routerLink="/main/parametre/marque-categorie/categories" 
                  class="list-group-item list-group-item-action"
                  routerLinkActive="active"
                  (click)="changeActive('m-c')"
                >
                  <i [size]="18" data-feather="grid" class="mr-75"></i>
                  <span class="align-middle">Marques, Catégories et Unités</span>
                </a>
                </ng-container>

                <ng-container *ngIf="showParametreDonneesNav">
                  <a
                    routerLink="/main/parametre/donnees/produits"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="shopping-cart" class="mr-75"></i>
                    <span class="align-middle">Produits</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/clients"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="users" class="mr-75"></i>
                    <span class="align-middle">Clients</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/fournisseurs"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="truck" class="mr-75"></i>
                    <span class="align-middle">Fournisseurs</span>
                  </a>
                  <!--
                  <a
                    routerLink="/main/parametre/donnees/documents-vente"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="file-text" class="mr-75"></i>
                    <span class="align-middle">Documents vente</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/documents-achat"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="clipboard" class="mr-75"></i>
                    <span class="align-middle">Documents achat</span>
                  </a>
                  -->
                  <a
                    routerLink="/main/parametre/donnees/lignes-document"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="list" class="mr-75"></i>
                    <span class="align-middle">Lignes document</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/promotions"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="percent" class="mr-75"></i>
                    <span class="align-middle">Promotions</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/tarifs"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="tag" class="mr-75"></i>
                    <span class="align-middle">Tarifs</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/stock"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="package" class="mr-75"></i>
                    <span class="align-middle">Stock</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/entrepots"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="archive" class="mr-75"></i>
                    <span class="align-middle">Entrepôts</span>
                  </a>
                  <a
                    routerLink="/main/parametre/donnees/boutiques"
                    class="list-group-item list-group-item-action"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="donneesSubLinkActiveOptions"
                    (click)="changeActive('p-db')"
                  >
                    <i [size]="18" data-feather="shopping-bag" class="mr-75"></i>
                    <span class="align-middle">Boutiques</span>
                  </a>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </core-sidebar>

    <!-- Content Right -->
    <div class="content-right custom-scroll" style="overflow: auto;">
      <div class="content-wrapper p-0 conten-right-r "  >
        <div class="card">
          <div class="card-body ">
            <router-outlet></router-outlet>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
